const column = [
  {
    label: "Index name",
    field: "basics_name"
  },
  {
    label: "Country/Region",
    field: "country_cn_simplename"
  },
  {
    label: "Statistical cycle",
    field: "statperiod_cn_description"
  },
  {
    label: "Unit",
    field: "unit_cn_description"
  },
  {
    label: "Source",
    field: "original_data_source"
  }
]

export default column;